"use strict";
const carbucks = carbucks || {};
const faqToggles = document.getElementsByClassName("js-faq-item-toggle");

carbucks.faq =
  carbucks.faq ||
  (function() {
    function init() {
      if (faqToggles.length) {
        for (let i = 0; i < faqToggles.length; i++) {
          const currentToggle = faqToggles[i];
          const currentParent = currentToggle.parentNode;
          const currentText = currentParent.querySelector(".js-faq-item-text");

          currentToggle.addEventListener("click", function(e) {
            const clickedItem = e.currentTarget;
            const parentItem = clickedItem.parentNode;
            const text = parentItem.querySelector(".js-faq-item-text");
            const currentTextHeight = currentText.scrollHeight;

            if (currentParent.classList.contains("item-faq--open")) {
              currentParent.classList.remove("item-faq--open");
              text.style.maxHeight = "0";
            } else {
              currentParent.classList.add("item-faq--open");
              text.style.maxHeight = currentTextHeight + "px";
            }
          });
        }
      }
    }
    function closeAll() {
      const openFaqs = document.getElementsByClassName("item-faq--open");

      for (let i = 0; i < openFaqs.length; i++) {
        const currentToggle = openFaqs[i];
        const currentParent = currentToggle.parentNode;
        const currentText = currentParent.querySelector(".js-faq-item-text");
        currentToggle.classList.remove("item-faq--open");
        currentText.style.maxHeight = "0";
      }
    }
    return {
      init: init,
    };
  })();
